









import { Vue } from "vue-property-decorator";
export default Vue.extend({
  props: {
    alphabet: {
      type: String
    }
  },
  data(){
    return{
      currentLetter: ""
    }
  },
  methods: {
    isActive(letter: string) {
      return false;
    },
    scrollTo(el : string){
      this.$scrollTo(el, 10, {container: '#list'})
    },
    movingScroll(event : any){
      let mousePosition
      if(typeof event.changedTouches !== 'undefined'){
        /** Si on se trouve dans un ecran tactile */
        mousePosition = event.changedTouches[0]
      }else{
        /** sinon */
        mousePosition = event
      }
      /** Recuperer l'element html dans le DOM a partir de la position de la souri */
      let element = document.elementFromPoint(mousePosition.clientX, mousePosition.clientY)
      /** si l'elementy existe et on a changer de position */
      if(element && element.innerHTML.length===1 && element.innerHTML !== this.currentLetter){
        this.currentLetter = element.innerHTML
        let letter = element.innerHTML.toLowerCase()
        let elementId = '#'+letter
        this.scrollTo(elementId)
      }
    }
  }
});
